import { addAllToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { DeleteMessageFulfilledAction } from '../../../domains/deleteMessage/actions.types';
import type {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../../domains/feedLoad/actions.types';
import type {
  ThreadPinToEventFeedFulfilledAction,
  ThreadUnpinFromEventFeedFulfilledAction,
} from '../../../domains/pinnedThreads/actions.types';
import type { ThreadMoveCompletedAction } from '../../../domains/threadMove/actions.types';
import {
  removeThreadFromAnyPinnedInstance,
  removeThreadFromAnyPinnedInstanceIfDeleted,
} from '../removeDeletedPinnedThread';
import type { ThreadsPinnedToFeeds } from '../types';
export type ThreadsPinnedToEventFeedsAction =
  | DeleteMessageFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | ThreadMoveCompletedAction
  | ThreadPinToEventFeedFulfilledAction
  | ThreadUnpinFromEventFeedFulfilledAction;
const initialState: ThreadsPinnedToFeeds = {};
const reducer: Reducer<ThreadsPinnedToFeeds, ThreadsPinnedToEventFeedsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToEventFeeds);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToEventFeeds);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToEventFeeds);
    case 'THREAD.PIN_TO_EVENT_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToEventFeeds);
    case 'THREAD.UNPIN_FROM_EVENT_FULFILLED':
      return addAllToRecord(state, action.payload.entities.threadsPinnedToEventFeeds);
    case 'MESSAGE.DELETE_FULFILLED':
      return removeThreadFromAnyPinnedInstanceIfDeleted(
        state,
        action.payload.threadId,
        action.payload.deletionOutcome === 'THREAD_REMOVED'
      );
    case 'THREAD.MOVE_COMPLETED':
      return removeThreadFromAnyPinnedInstance(state, action.payload.threadId);
    default:
      return state;
  }
};
export default reducer;
